<template>
    <div id="Events">
        <mobileHeader v-if="isMobile == 'Mobile'" touterNum=2></mobileHeader>
        <Header v-else></Header>
        <backhead :title="titleLabel"></backhead>
        <div class="mainbox app-content" :class="{ Mobileclass: isMobile == 'Mobile' }">
            <div class="hasline">
                <div class="list flex">
                    <div class="box" v-for="(item, index) in arrList" :key="index" @click="todetails(item.id)">
                        <video :src="item.image" alt="" class="pic" controls></video>
                        <p class="tit app-title">{{item.title}}</p>
                        <p class="tim">{{item.created_at}}</p>
                    </div>
                    <div class="box" v-if="arrList.length % 4 > 1"></div>
                    <div class="box" v-if="arrList.length % 4 == 2"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
    import { ref, watch, computed } from 'vue';
    import { getshowList } from "../utils/gerData";
    import { currentLanguage } from "../utils/lang";
    import { backheadTitles,imageurl } from "../utils/i18nLabels";
    import router from '@/router';
    const isMobile = localStorage.getItem('userAgent')

    const arrList = ref([]);
    const titleLabel = computed(() => backheadTitles.videos[currentLanguage.value || 'zh'])
    // 获取列表数据
    function getList() {
        let queryParams = {
            page: 1,
            pageSize: 100,
            pid: 6
        }
        getshowList(queryParams).then(res => {
            const data = res.data
            data.list.map(item => {
                item.image = item.image ? imageurl + item.image : undefined
                item.created_at = item.created_at.slice(0, 4) + '.' + item.created_at.slice(5, 7) + '.' + item.created_at.slice(8, 10)
            })
            arrList.value = data.list;
        });
    }
    // 跳详情
    function todetails(id) {
        router.push("/mediadetails?id=" + id)
    }
    getList()

    watch(currentLanguage, () => {
        getList()
    })
</script>

<style scoped>
    #Events{
        overflow: hidden;
    }
    .mainbox{
        margin-top: 200px;
        text-align: left;
    }
    .hasline{
        border-bottom: 2px solid #f0f0f0;
        overflow: hidden;
        padding: 0 60px;
    }
    h3{
        font-size: 36px;
        color: #232323;
        font-weight: normal;
        padding: 60px 60px 0;
    }
    .list{
        flex-wrap: wrap;
        margin: 80px 0 40px 0;
        align-items: flex-start;
        .box{
            width: 24%;
            margin-bottom: 80px;
            .pic{
                width: 100%;
                height: 200px;
                object-fit: cover;
                display: block;
            }
            .tit{
                font-size: 20px;
                color: #000;
                margin: 10px 0;
            }
            .tim{
                font-size: 16px;
                color: #3a3a3a;
            }
        }
    }
    .imgtxt{
        align-items: flex-start;
        img{
            width: 38%;
        }
        div{
            width: 58%;
        }
        h5{
            font-size: 28px;
            color: #000;
            margin-bottom: 20px;
        }
        p{
            color: #3f3f3f;
            font-size: 24px;
        }
    }

    .Mobileclass{
        margin-top: 160px;
        h3{
            font-size: 32px;
            padding: 0 22px;
        }
        .hasline{
            padding: 22px;
            border: none;
            .imgtxt {
                display: block;
                img{
                    width: 100%;
                    display: block;
                    margin: 10px 0;
                }
                div{
                    width: 100%;
                }
                h5{
                    font-size: 28px;
                    margin: 20px 0;
                }
            }
        }
        .list{
            display: block;
            margin: 0;
        }
        .box{
            width: 100%;
            margin-bottom: 40px;
            .tit{
                font-size: 20px;
                margin: 10px 0;
            }
            .tim{
                font-size: 16px;
                color: #3a3a3a;
            }
        }
    }
</style>